import { Fragment, type FC } from 'react';

import { Card } from '@mint-lib/tw-components';

import { OperationTypesEnum } from '../constants/shared.js';
import type { LogicalGroupType } from '../types/shared.js';
import LogicalRow from './LogicalRow.jsx';
import Separator from './Separator.jsx';

type Props = {
  rows: LogicalGroupType;
  approvalProcessId: string;
  reminderSendingAllowed: boolean;
};

const LogicalGroup: FC<Props> = ({
  rows,
  approvalProcessId,
  reminderSendingAllowed,
}) => {
  return (
    <div className="flex items-center gap-x-2 gap-y-1">
      <Card variant="outlined" className="w-full">
        <div className="grid gap-3">
          {rows.map((row, index) => {
            return (
              <Fragment key={JSON.stringify(row)}>
                {index === 0 ? null : (
                  <Separator variant={OperationTypesEnum.enum.and} />
                )}
                <LogicalRow
                  {...row}
                  approvalProcessId={approvalProcessId}
                  reminderSendingAllowed={reminderSendingAllowed}
                />
              </Fragment>
            );
          })}
        </div>
      </Card>
    </div>
  );
};

export default LogicalGroup;
